import '../CreateEditDialog.scss';

import { InputText } from 'primereact/inputtext';
import { ChangeEvent } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { invalidDecimalPointCharactersRegex } from '../../../../../../utils/constants/regex';
import FieldWithErrors from '../../../../../Forms/ReactHookForm/FieldWithErrors';

function StatsTab() {
  const { t } = useTranslation();

  return (
    <div className="stats-tab">
      <div className="p-grid">
        <div className="p-col-12 p-md-6">
          <FieldWithErrors
            name="incomingCashPercent"
            label={t('Incoming Cash Percent')}
          >
            <Controller
              name="incomingCashPercent"
              render={({ field }) => (
                <InputText
                  id="incomingCashPercent"
                  name="incomingCashPercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="incomingCashPercent"
                />
              )}
            />
          </FieldWithErrors>
          <FieldWithErrors
            name="incomingInvoicePercent"
            label={t('Incoming Invoice Percent')}
          >
            <Controller
              name="incomingInvoicePercent"
              render={({ field }) => (
                <InputText
                  id="incomingInvoicePercent"
                  name="incomingInvoicePercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="incomingInvoicePercent"
                />
              )}
            />
          </FieldWithErrors>
        </div>
        <div className="p-col-12 p-md-6">
          <FieldWithErrors
            name="internationalCashPercent"
            label={t('International Cash Percent')}
          >
            <Controller
              name="internationalCashPercent"
              render={({ field }) => (
                <InputText
                  id="internationalCashPercent"
                  name="internationalCashPercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="internationalCashPercent"
                />
              )}
            />
          </FieldWithErrors>
          <FieldWithErrors
            name="internationalInvoicePercent"
            label={t('International Invoice Percent')}
          >
            <Controller
              name="internationalInvoicePercent"
              render={({ field }) => (
                <InputText
                  id="internationalInvoicePercent"
                  name="internationalInvoicePercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="internationalInvoicePercent"
                />
              )}
            />
          </FieldWithErrors>
          <FieldWithErrors
            name="outgoingCashPercent"
            label={t('Outgoing Cash Percent')}
          >
            <Controller
              name="outgoingCashPercent"
              render={({ field }) => (
                <InputText
                  id="outgoingCashPercent"
                  name="outgoingCashPercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="outgoingCashPercent"
                />
              )}
            />
          </FieldWithErrors>
          <FieldWithErrors
            name="outgoingInvoicePercent"
            label={t('Outgoing Invoice Percent')}
          >
            <Controller
              name="outgoingInvoicePercent"
              render={({ field }) => (
                <InputText
                  id="outgoingInvoicePercent"
                  name="outgoingInvoicePercent"
                  value={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(
                      e.target.value?.replace(
                        invalidDecimalPointCharactersRegex,
                        ''
                      )
                    );
                  }}
                  data-cy="outgoingInvoicePercent"
                />
              )}
            />
          </FieldWithErrors>
        </div>
      </div>
    </div>
  );
}

export default StatsTab;
